export interface SEOMeta {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType: string;
}

export const defaultSEO: SEOMeta = {
  title: "吃瓜黑料在线 - 51吃瓜黑料在线观看 | 吃瓜黑料在线官网入口 网红塌房现场黑料实时更新",
  description: "吃瓜黑料在线首页聚合站，实时更新51吃瓜在线观看、黑料在线、网红塌房现场、明星黑料爆料等内容，提供吃瓜黑料在线官网入口、app下载指引，每日不间断追踪网络热点事件。",
  keywords: "51吃瓜在线, 51吃瓜在线观看, 黑料在线, 吃瓜在线, 在线吃瓜, 黑料在线观看, 吃瓜黑料在线播放, 吃瓜黑料在线官网, 吃瓜黑料在线入口, 吃瓜黑料在线app",
  canonicalUrl: "https://www.chiguaheiliaozx.com",
  ogType: "website",
};

export const pageSEO: Record<string, SEOMeta> = {
  home: defaultSEO,
  category: {
    title: "分类浏览 - 吃瓜黑料在线 | 按类别追踪最新黑料",
    description: "按网红塌房、明星爆料、直播翻车、娱乐圈内幕、综艺八卦、电竞吃瓜等分类浏览吃瓜黑料在线全部内容，精准追踪你最关注的八卦类型。",
    keywords: "吃瓜分类, 网红塌房, 明星爆料, 直播翻车, 娱乐圈内幕, 综艺八卦, 电竞吃瓜",
    canonicalUrl: "https://www.chiguaheiliaozx.com/category",
    ogType: "website",
  },
  about: {
    title: "关于我们 - 吃瓜黑料在线 | 品牌介绍与联系方式",
    description: "了解吃瓜黑料在线的品牌故事、团队背景和核心价值。我们致力于为吃瓜群众提供最快、最全、最真实的娱乐八卦资讯。查看联系方式与常见问题。",
    keywords: "吃瓜黑料在线介绍, 关于吃瓜黑料, 吃瓜黑料联系方式, 吃瓜黑料品牌, 黑料平台介绍",
    canonicalUrl: "https://www.chiguaheiliaozx.com/about",
    ogType: "website",
  },
};